import { AxiosResponse } from "axios";

import API from "../api";

import { Customer, CustomerInviteParams } from "../models/customer";

const ROUTE_NAME = "customers";

const CustomerService = {
  async count(options?: any): Promise<AxiosResponse<number>> {
    return await API.get(`/${ROUTE_NAME}/count`, { params: options });
  },
  async getById(id: number, options?: any): Promise<AxiosResponse<Customer>> {
    return await API.get(`/${ROUTE_NAME}/${id}`, { params: options });
  },
  async getAll(options?: any): Promise<AxiosResponse<Customer[]>> {
    return await API.get(`/${ROUTE_NAME}`, { params: options });
  },
  async create(customer: Customer): Promise<AxiosResponse<any>> {
    return await API.post(`/${ROUTE_NAME}`, customer);
  },
  async update(id: number, customer: Customer): Promise<AxiosResponse<boolean>> {
    return await API.put(`/${ROUTE_NAME}/${id}`, customer);
  },
  async delete(id: number): Promise<AxiosResponse<Customer>> {
    return await API.delete(`/${ROUTE_NAME}/${id}`);
  },
  async inviteToShipeezi(inviteParams: CustomerInviteParams): Promise<AxiosResponse<boolean>> {
    return await API.post(`/${ROUTE_NAME}/invite`, inviteParams);
  },
};

export default CustomerService;
